import React from 'react';
import useCountUp from '../../hooks/useCountUp';

interface AnimatedNumberProps {
  value: number;
  decimals?: number;
  duration?: number;
  className?: string;
}

/** Stat number that counts up on mount. Tabular mono comes from the parent's font class. */
const AnimatedNumber: React.FC<AnimatedNumberProps> = ({
  value,
  decimals = 1,
  duration = 800,
  className,
}) => {
  const display = useCountUp({ end: value, duration, decimals });
  return <span className={className}>{display.toFixed(decimals)}</span>;
};

export default AnimatedNumber;
